import PropTypes from 'prop-types';

export const DishesCategoriesModel = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  dishesSubcategories: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      dishes: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string,
          id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        })
      )
    })
  )
});

export const MenuModel = {
  menuDate: PropTypes.string,
  title: PropTypes.string,
  especial: PropTypes.bool,
  allergensUrl: PropTypes.string,
  dishesCategories: PropTypes.arrayOf(DishesCategoriesModel),
  menuWellness: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      dishes: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
          name: PropTypes.string
        })
      )
    })
  )
};
